import { ActionsQuestion } from './categories/question/ActionsQuestion';
import { ActionsLearnware } from './categories/learnware/ActionsLearnware';
import { ActionsEvent } from './categories/event/ActionsEvent';
import { ActionsTopic } from './categories/topic/ActionsTopic';
import { RegistryRoof } from '../RegistryRoof';
import { ActionsAsking } from './categories/memory/ActionsAsking';
import { ActionsDirective } from './categories/ActionsDirective';
export class ActionRegistry extends RegistryRoof {
    registryType = 'action';
    c_mt = new ActionsAsking(this);
    c_event = new ActionsEvent(this); // do not modify name - is referenced
    c_l = new ActionsLearnware(this);
    c_d = new ActionsDirective(this);
    c_q = new ActionsQuestion(this);
    c_t = new ActionsTopic(this);
    get registry_object() {
        return super.registry_object;
    }
}
